import { Component, Input, ChangeDetectorRef, ElementRef, ChangeDetectionStrategy, SkipSelf, Renderer2 } from '@angular/core';
import { Cell, TableEventsService, RegularCellComponent } from '@schoolbelle/common/table';
import { GroupMember, GroupMemberType } from '@schoolbelle/api/group-member';
import { TreeGroup } from '@schoolbelle/api/group-to-group';
import { MailmergeTableService } from '../mailmerge-table.service';
import { merge } from 'lodash';

@Component({
  selector: '[membersearch-cell]',
  templateUrl: './membersearch-cell.component.html',
  styleUrls: ['./membersearch-cell.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class MembersearchCellComponent extends RegularCellComponent {
  @Input() class_cell:Cell;
  @Input() type_cell:Cell;
  @Input() memberType:GroupMemberType;
  @Input() searchFor:'class'|'type'|'name'|'phone-number';
  constructor(
    hover:TableEventsService,
    elRef:ElementRef,
    renderer:Renderer2,
    cdRef:ChangeDetectorRef,
    private mailmergeTableService:MailmergeTableService,
    
  ) { 
    super(hover, elRef, renderer, cdRef);
  }

  ngOnInit() {
    super.ngOnInit();
    this.subscriptions.add(
      merge(
        this.cell.row.onSizeChange,
        // this.cell.onInvalid
      )
      .subscribe(()=>this.cdRef.detectChanges())
    )
  }

  getMatchedClasses (query_in_classes:string, query_in_grades?:string) {
    return this.mailmergeTableService.filterClasses(query_in_classes, query_in_grades)
    .map(([cls, grd])=>( cls ? {
      display:cls.group_name, 
      val:cls.group_name,
      class:cls,
      grade:grd,
    } : null)).filter(v=>v)
  }
  getMatchedMembers (query_in_members:string, query_in_types?:GroupMemberType[], query_in_classes?:string, query_in_grades?:string) {
    return this.mailmergeTableService.filterMembers(query_in_members, query_in_types, query_in_classes, query_in_grades)
    .map(([m, cls, grd])=>{
      return m ? {
        display:`${m.group_name} ${m.member_num}번 ${(m.member_name || '-')}`,
        val: m.member_name,
        class:cls,
        grade:grd,
        member:m,
      } : null;
    }).filter(v=>v); 
  }
  getMatchedMembersDirectly (query_in_members:string, memberType:GroupMemberType) {
    return this.mailmergeTableService.filterMembersDirectly(query_in_members, [memberType])
    .map((m)=>({
      display:`${m.group_name} ${m.member_num}번 ${(m.member_name || '-')}`,
      val: m.member_name,
      member:m,
    })) 
  }
  getMatchedList () {
    const val = this.cell.val;
    switch (this.searchFor) {
      case 'class':
        return this.getMatchedClasses(val);
      case 'type': // this will be used as hidden
        return [];
      case 'name':
        if (this.class_cell && this.class_cell.val) return this.getMatchedMembers(val, [this.memberType], this.class_cell.val);
        else return this.getMatchedMembersDirectly(val, this.memberType);
      default:
        return [];
    }
  }
  /**
   * this should be improved to fill other related empty cells when match is found.
   * @param query_in_members 
   * @param query_in_classes 
   * @param query_in_grades 
   */
  select (item:{val:string, display:string, member?:GroupMember, cls?:TreeGroup, grd?:TreeGroup}) {
    const {val, member} = item;
    let newCellValue:string;
    if (this.searchFor === 'name' && member) {
      newCellValue = member.member_name;

      if (this.class_cell && this.class_cell.val !== member.group_name) {
        this.class_cell.val = member.group_name;
        this.class_cell.set('member', member);
      }
      if (this.type_cell && this.type_cell.val !== member.member_type) {
        this.type_cell.val = member.member_type;
      }
    } 
    else {
      newCellValue = val;
    }

    // /**
    //  * Added at 2020.11.25 
    //  * without setTimeout, there seems to be a racing condition between input value update and cell value update
    //  */
    // setTimeout(()=>{
    //   this.cell.val = newCellValue
    // }, 10)
    this.cell.val = newCellValue

  }
}
